export default {
    API_ENDPOINT: 'https://peaceful-wave-86345.herokuapp.com',
    TOKEN_KEY: 'bnr-client-auth-token'
}